import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface SectionCardIconeTituloLinkClick {
  externalLink?: string;
  page?: string;
  document?: string;
}

export interface SectionCardIconeTituloLinkData {
  highlightText: string;
  icon: string;
  externalLink: string;
  page: string;
  document: string;
  hasTxtUrl: boolean;
}

@Component({
  selector: 'fcp-section-card-icone-titulo-link',
  templateUrl: './section-card-icone-titulo-link.component.html',
  styleUrls: ['./section-card-icone-titulo-link.component.scss']
})
export class SectionCardIconeTituloLinkComponent {

  @Input() public sectionCardIconeTituloLink: SectionCardIconeTituloLinkData;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();

  public emitClick(link: SectionCardIconeTituloLinkClick): void {
    if (link.page) {
      this.wasClickedPage.emit(link.page);
    } else if(link.externalLink) {
      this.wasClicked.emit(link);
    } else if(link.document) {
      window.open(link.document,'_blank');
    }

  }

}
